/* eslint-disable camelcase */
import Api from '@/repository/index'
import globalMixin from '@/mixin/global'
import { saveExcel } from '@/utils/saveExel'
import { Message } from 'element-ui'
import moment from 'moment/moment'

const { getUtcFromDate } = globalMixin.methods

const state = {
  drivers: [],
  driversSearchList: [],
  filters: {
    start_date: null,
    end_date: null,
  },
  local_filters: {
    FIO: null,
    category: null,
    sort: null,
  },
  isLoading: true,
}

const mutations = {
  SET_DRIVERS: (state, data) => {
    state.drivers = data
  },
  SET_FILTERS: (state, data) => {
    state.filters = {
      ...state.filters,
      ...data,
    }
  },
  SET_LOCAL_FILTERS: (state, data) => {
    state.local_filters = {
      ...state.local_filters,
      ...data,
    }
  },
  TOOGLE_LOADING(state, value) {
    state.isLoading = value
  },
  SET_SEARCH_DRIVERS: (state, value) => {
    state.driversSearchList = value
  },
}

const getters = {
  getDriversByLocalFilters: (state) => {
    const { FIO, category, sort, sort_current_sum } = state.local_filters
    let returnData = [...state.drivers]
    if (FIO) {
      returnData = returnData.filter((driver) =>
        driver?.driverFullName?.toLocaleUpperCase().includes(FIO.toLocaleUpperCase()),
      )
    }
    if (category?.length > 0) {
      returnData = returnData.filter((driver) => category?.includes(driver?.transactionCategory))
    }
    if (sort) {
      if (sort === 'ASC') {
        returnData.sort((a, b) => {
          const nA = a.driverFullName.toLowerCase()
          const nB = b.driverFullName.toLowerCase()

          if (nA < nB) {
            return -1
          } else if (nA > nB) return 1
          return 0
        })
      }
      if (sort === 'DESC') {
        returnData.sort((a, b) => {
          const nA = a.driverFullName.toLowerCase()
          const nB = b.driverFullName.toLowerCase()

          if (nB < nA) {
            return -1
          } else if (nA > nB) return 1
          return 0
        })
      }
    }

    if (sort_current_sum) {
      if (sort_current_sum === 'ASC') {
        returnData.sort((a, b) => {
          const nA = a?.currentSum
          const nB = b?.currentSum

          if (nA < nB) {
            return -1
          } else if (nA > nB) return 1
          return 0
        })
      }
      if (sort_current_sum === 'DESC') {
        returnData.sort((a, b) => {
          const nA = a?.currentSum
          const nB = b?.currentSum

          if (nB < nA) {
            return -1
          } else if (nA > nB) return 1
          return 0
        })
      }
    }
    return returnData
  },
  getDriversCategories: (state) => {
    const getAll = state.drivers?.map((x) => x?.transactionCategory).filter((x) => x)
    return [...new Set(getAll)]
  },
  getDriversByArgument: (_, getters) => {
    return (type = 'ASC') => {
      return getters.getDriversByLocalFilters.reduce((acc, value) => {
        if (value?.shiftCount === 0 && type === 'ASC') {
          acc = [...acc]
          return acc
        }

        if (value?.shiftCount >= 1 && type === 'DESC') {
          acc = [...acc]
          return acc
        }
        const getStartDate = value?.startDateBalance
        const diff = Number(value?.endDateBalance) - Number(getStartDate)
        acc = [
          ...acc,
          {
            ...value,
            diff,
            startDateBalance: getStartDate,
          },
        ]
        return acc
      }, [])
    }
  },
}

const actions = {
  async fetchSaveExelByBalances({ state }, params) {
    try {
      const { csv } = await Api.tenants.balance.fetchSaveDeptsExel(
        {
          startDate: moment
            .utc(params.fromDate ?? state.filters.start_date)
            .startOf('day')
            .toISOString(),
          endDate: moment
            .utc(params.toDate ?? state.filters.end_date)
            .startOf('day')
            .toISOString(),
        },
        params.separator,
      )

      saveExcel('отчет по водителям', csv)

      Message({
        message: 'Excel успешно скачан!',
        type: 'success',
        duration: 5 * 1000,
      })
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async fetchSearchDriver({ commit }, params) {
    try {
      const r = await Api.tenants.balance.getSearchDrivers({
        searchPhrase: params,
      })

      commit('SET_SEARCH_DRIVERS', r)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async fetchSaveExelByDebts(_, params) {
    try {
      const { csv } = await Api.tenants.balance.fetchSaveDebtsExel(
        {
          startDate: moment
            .utc(params.fromDate ?? state.filters.start_date)
            .startOf('day')
            .toISOString(),
          endDate: moment
            .utc(params.toDate ?? state.filters.end_date)
            .startOf('day')
            .toISOString(),
        },
        params.separator,
      )

      saveExcel('отчет по водителям', csv)

      Message({
        message: 'Excel успешно скачан!',
        type: 'success',
        duration: 5 * 1000,
      })
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async fetchSaveExelByDeposit(_, params) {
    try {
      const { csv } = await Api.tenants.deposit.fetchSaveExel(
        {
          startDate: moment
            .utc(params.fromDate ?? state.filters.start_date)
            .startOf('day')
            .toISOString(),
          endDate: moment
            .utc(params.toDate ?? state.filters.end_date)
            .startOf('day')
            .toISOString(),
        },
        params.separator,
      )

      saveExcel('отчет по водителям', csv)

      Message({
        message: 'Excel успешно скачан!',
        type: 'success',
        duration: 5 * 1000,
      })
    } catch (e) {
      return Promise.reject(e)
    }
  },
  setFiltersDates({ commit }, { start_date, end_date }) {
    try {
      commit('SET_FILTERS', {
        start_date,
        end_date,
      })
    } catch (e) {}
  },
  setLocalFiltersDates({ commit }, data) {
    try {
      commit('SET_LOCAL_FILTERS', data)
    } catch (e) {}
  },
  async getDriverBalanceDebts({ commit }, { start_date, end_date, region_park_id }) {
    try {
      commit('TOOGLE_LOADING', true)
      const data = await Api.tenants.balance.getDriverBalanceDebts({
        startDate: getUtcFromDate(start_date),
        endDate: getUtcFromDate(end_date),
        region_park_id: region_park_id,
      })
      commit('SET_DRIVERS', data)
      commit('TOOGLE_LOADING', false)
    } catch (e) {
      commit('TOOGLE_LOADING', false)
      return Promise.reject(e)
    }
  },
  async getDriverBalancesDebts({ commit }, { start_date, end_date, driverId }) {
    try {
      commit('TOOGLE_LOADING', true)
      const payload = {
        startDate: getUtcFromDate(start_date),
        endDate: getUtcFromDate(end_date),
        ...(driverId?.length ? { driverIds: [driverId] } : {}),
      }

      const data = await Api.tenants.balance.getDriverBalancesDebts(payload)
      commit('SET_DRIVERS', data)
      commit('TOOGLE_LOADING', false)
    } catch (e) {
      commit('TOOGLE_LOADING', false)
      return Promise.reject(e)
    }
  },
  async getDriverDeptsReport({ commit }, { start_date, end_date, driverId }) {
    try {
      commit('TOOGLE_LOADING', true)
      const payload = {
        startDate: getUtcFromDate(start_date),
        endDate: getUtcFromDate(end_date),
        ...(driverId?.length ? { driverIds: [driverId] } : {}),
      }

      const data = await Api.tenants.deposit.getDriverDeptsReport(payload)
      commit('SET_DRIVERS', data)
      commit('TOOGLE_LOADING', false)
    } catch (e) {
      commit('TOOGLE_LOADING', false)
      return Promise.reject(e)
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
